// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + ({"2143":"app","9818":"auth"}[chunkId] || chunkId) + "." + {"2143":"e98b0b58","6002":"9c7bc50e","6178":"aa526590","9663":"658dd42a","9818":"c80bd0ad"}[chunkId] + ".chunk.css";
};